import { useEffect, useState } from "react";
import styles from "./Pagination.module.css";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export default function Pagination({
  page,
  totalPages,
  onPageChange,
  pagesPerGroup = 10,
}) {
  const currentGroup = Math.ceil(page / pagesPerGroup);

  const startPage = (currentGroup - 1) * pagesPerGroup + 1;
  const endPage = Math.min(startPage + pagesPerGroup - 1, totalPages);

  return (
    <div className={cx("pageWrap")}>
      {startPage > 1 && (
        <div onClick={() => onPageChange(startPage - 1)}>이전</div>
      )}

      {Array.from(
        { length: endPage - startPage + 1 },
        (_, i) => startPage + i
      ).map((num) => (
        <div
          key={num}
          onClick={() => onPageChange(num)}
          className={cx({ active: num === page })}
        >
          {num}
        </div>
      ))}

      {endPage < totalPages && (
        <div onClick={() => onPageChange(endPage + 1)}>다음</div>
      )}
    </div>
  );
}
